<template>
  <div class="header">
    <div class="header__bg"></div>
    <div class="header__overlay"></div>
    <div class="header__logo logo"></div>
    <div class="header__wrapper" v-if="loggedIn">
      <h2 v-t="`serviceclasses.${serviceClass}`"></h2>
      <p class="header__number">{{ msisdn }}</p>
      <i18n tag="p" class="header__effect smaller" path="frontpage.validUntil"
        ><span place="date">{{ validUntil }}</span></i18n
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msisdn: {
      type: String,
    },
    validUntil: {
      type: String,
    },
    serviceClass: {
      type: Number,
    },
    loggedIn: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>

<style lang="scss" scoped>
$white: #fff;

.header {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 200px;
  min-height: 165px;
  padding: 10px 16px;
  overflow: hidden;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/img/laturi_bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: blur(2px);
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(#000, 0.25);
    z-index: 0;
  }

  &__logo {
    position: absolute;
    margin-top: 5px;
    top: env(safe-area-inset-top, 0px);
    width: 32px;
    height: 32px;
    z-index: 1;

    @include breakpoint-up(md) {
      top: 20px;
      left: 40px;
    }

    &.logo {
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(~@/assets/svg/dna_logo.svg);
    }
  }

  &__wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
    top: env(safe-area-inset-top);
  }

  &__number {
    margin: 2px 0 10px;
    font-size: 18px;
  }

  &__effect {
    margin: 0;
  }

  h2,
  p {
    color: $white;
  }

  h2 {
    margin: 0;
    @include font-bold;
  }
}
</style>
